export default {
	data() {
		return {
			isMobile: false,
			isTablet: false,
			screenWidth: 0
		}
	},
	mounted() {
		this.detectDevice()
		window.addEventListener('resize', this.detectDevice)
	},
	beforeDestroy() {
		window.removeEventListener('resize', this.detectDevice)
	},
	methods: {
		detectDevice() {
			this.screenWidth = window.innerWidth
			this.isMobile = window.innerWidth <= 768 || /Android|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
			this.isTablet = window.innerWidth > 768 && window.innerWidth <= 1024
		}
	},
	computed: {
		deviceClass() {
			return {
				'mobile-layout': this.isMobile,
				'tablet-layout': this.isTablet,
				'desktop-layout': !this.isMobile && !this.isTablet
			}
		}
	}
}